import Tab from "components/Tab";
import APISendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-api.mdx";
import WebSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-web.mdx";
import ReactSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-react.mdx";
import NodeSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-node.mdx";
import PythonSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-python.mdx";
import PHPSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-php.mdx";
import RubySendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ruby.mdx";
import GoSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-go.mdx";
import ReactNativeSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-react-native.mdx";
import AndroidSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-android.mdx";
import IOSSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ios.mdx";
import JavaSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-java.mdx";
import RustSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-rust.mdx";
import FlutterSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-flutter.mdx";
import ElixirSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-elixir.mdx";
import * as React from 'react';
export default {
  Tab,
  APISendEvent,
  WebSendEvent,
  ReactSendEvent,
  NodeSendEvent,
  PythonSendEvent,
  PHPSendEvent,
  RubySendEvent,
  GoSendEvent,
  ReactNativeSendEvent,
  AndroidSendEvent,
  IOSSendEvent,
  JavaSendEvent,
  RustSendEvent,
  FlutterSendEvent,
  ElixirSendEvent,
  React
};